import React, { useState } from 'react';
import { apiClient } from '../lib/apiClient';
import { supabase } from '../lib/supabaseClient';

interface LoginProps {
  onLoginSuccess?: () => void;
}

export default function Login({ onLoginSuccess }: LoginProps) {
  const [email, setEmail] = useState('admin@contedusoir.app');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const formatErrorMessage = (errMsg: string): string => {
    if (errMsg.includes('Unexpected end of JSON input') || errMsg.includes('Failed to execute')) {
      return 'Erreur de réponse du serveur. Vérifiez les identifiants ou la connexion Supabase DEV.';
    }
    return errMsg;
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await apiClient.login(email, password);
      try {
        await supabase.auth.signInWithPassword({ email, password });
      } catch (_sErr) {
        // Supabase optional
      }

      if (onLoginSuccess) {
        onLoginSuccess();
      } else {
        window.location.reload();
      }
    } catch (err: any) {
      const { error: sError } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (sError) {
        const msg = err?.message || sError.message || 'Identifiants invalides';
        setError(formatErrorMessage(msg));
      } else if (onLoginSuccess) {
        onLoginSuccess();
      } else {
        window.location.reload();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-16 p-8 bg-slate-900 rounded-xl border border-slate-800 shadow-2xl">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-slate-100">Connexion Back-Office</h2>
        <p className="text-sm text-slate-400 mt-1">Accès réservé à l'équipe éditoriale & administrative (JWT API & Supabase)</p>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-950/80 border border-red-800 text-red-300 text-sm rounded-lg">
          {error}
        </div>
      )}

      <form onSubmit={handleLogin} className="space-y-4">
        <div>
          <label className="block text-xs font-semibold text-slate-300 mb-1">Adresse Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-2.5 bg-slate-950 border border-slate-800 rounded-lg text-slate-100 focus:outline-none focus:border-amber-500"
            placeholder="admin@contedusoir.app"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-slate-300 mb-1">Mot de Passe</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full px-4 py-2.5 bg-slate-950 border border-slate-800 rounded-lg text-slate-100 focus:outline-none focus:border-amber-500"
            placeholder="••••••••••••"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 bg-amber-500 hover:bg-amber-400 font-semibold text-slate-950 rounded-lg transition shadow-lg disabled:opacity-50"
        >
          {loading ? 'Connexion en cours...' : 'Se Connecter'}
        </button>
      </form>
      <div className="mt-4 text-center text-xs text-slate-500">
        Dev default: <span className="text-amber-400 font-mono">admin@contedusoir.app</span> / <span className="text-amber-400 font-mono">ConteDuSoir2026!</span>
      </div>
    </div>
  );
}
